import React, { useContext } from "react"
import { Link } from "gatsby"
import styled from "styled-components"
import { displayCategory } from "../../utils/displayCategory"
import { FilterContext } from "../../providers/FilterProvider"
import { device } from "../../theme"

const Container = styled.div`
  display: flex;
  justify-content: flex-end;
`

const StyledLink = styled(Link)`
  color: #444;
  margin: 0 4px;
  text-transform: uppercase;
  font-size: 11px;

  &:hover {
    color: #444;
  }
`

const CurrentPage = styled.div`
  color: #444;
  margin: 0 4px;
  text-transform: uppercase;
  font-size: 11px;
  margin-right: 20px;

  @media ${device.tablet} {
    margin-right: 0;
  }
`

function Breadcrumbs({ gender, category }) {
  const { state } = useContext(FilterContext)

  if (category && !state.products.length) return null

  if (!category) {
    return (
      <Container>
        <StyledLink to="/">Forside</StyledLink>/
        <CurrentPage>{gender}</CurrentPage>
      </Container>
    )
  }

  return (
    <Container>
      <StyledLink to="/">Forside</StyledLink>/
      <StyledLink to={`/${gender}`}>{gender}</StyledLink>/
      <CurrentPage>{displayCategory(category)}</CurrentPage>
    </Container>
  )
}

export default Breadcrumbs
